import { supabase } from '../lib/supabase';

export interface CampaignLead {
  id: string;
  campaign_id: string;
  name: string;
  email: string;
  phone: string | null;
  created_at: string;
}

const list_leads = async (campaignId?: string): Promise<CampaignLead[]> => {
  let query = supabase.from('campaign_leads').select('*').order('created_at', { ascending: false });

  if (campaignId) {
    query = query.eq('campaign_id', campaignId);
  }

  const { data, error } = await query;

  if (error) {
    throw error;
  }

  return (data ?? []) as CampaignLead[];
};

export const campaignLeadService = {
  listLeads: (campaignId?: string): Promise<CampaignLead[]> => list_leads(campaignId),
};
